import ProcessTemplate from "@/types/documents/process/ProcessTemplate";
import { IDataProvider } from "@/store";

export interface IProcessTemplateState {
  processTemplate: ProcessTemplate | null;
  processTemplates: ProcessTemplate[] | null;
  dataProvider: IDataProvider<ProcessTemplate>;
}

export const state: IProcessTemplateState = {
  processTemplate: null,
  processTemplates: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};

export enum ProcessTemplateTypesEnum {
  ACTIVE = "ACTIVE",
  DISABLE = "DISABLE",
  SYSTEM = "SYSTEM",
}
